import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ArchiveRestore, CircleCheck, Package } from 'lucide-react';
import { Button } from '@ui/components/ui/button';
import { IncidentAction, incidentActionsFor } from './sources/incidentActions';
import { IncidentView } from './sources/incidents';

/** What each action looks like in a row. Which of them appear is `incidentActionsFor`'s call. */
const IncidentRowActions = ({
  incident,
  onResolve,
  onClose,
  onReopen,
}: {
  incident: IncidentView;
  onResolve: (incident: IncidentView) => void;
  onClose: (incident: IncidentView) => void;
  onReopen: (incident: IncidentView) => void;
}): ReactElement => {
  const { t } = useTranslation();

  const buttonFor: Record<IncidentAction, ReactElement> = {
    [IncidentAction.resolve]: (
      <Button size="sm" variant="ghost" key="resolve" onClick={() => onResolve(incident)}>
        <CircleCheck />
        {t('incidents.resolve')}
      </Button>
    ),
    [IncidentAction.close]: (
      <Button size="sm" variant="ghost" key="close" onClick={() => onClose(incident)}>
        <Package />
        {t('actions.close')}
      </Button>
    ),
    [IncidentAction.reopen]: (
      <Button size="sm" variant="ghost" key="reopen" onClick={() => onReopen(incident)}>
        <ArchiveRestore />
        {t('actions.reopen')}
      </Button>
    ),
  };

  return <>{incidentActionsFor(incident).map(action => buttonFor[action])}</>;
};

export default IncidentRowActions;
